/* globals self, window */
'use strict'; // Get around https://github.com/mysticatea/abort-controller/pull/22

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _get = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

var _ref = typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window
/* otherwise */
: require('abort-controller'),
    AbortController = _ref.AbortController;

var retimer = require('retimer');

var TimeoutController = /*#__PURE__*/function (_AbortController) {
  _inherits(TimeoutController, _AbortController);

  var _super = _createSuper(TimeoutController);

  /**
   * @constructor
   * @param {number} ms milliseconds
   */
  function TimeoutController(ms) {
    var _this;

    _classCallCheck(this, TimeoutController);

    _this = _super.call(this);
    _this._ms = ms;
    _this._timer = retimer(function () {
      return _this.abort();
    }, ms); // Patch for safari not supported extending built in classes

    Object.setPrototypeOf(_assertThisInitialized(_this), TimeoutController.prototype);
    return _this;
  }
  /**
   * Aborts the controller and clears the timer
   */


  _createClass(TimeoutController, [{
    key: "abort",
    value: function abort() {
      this._timer.clear();

      return _get(_getPrototypeOf(TimeoutController.prototype), "abort", this).call(this);
    }
    /**
     * Clears the timer
     */

  }, {
    key: "clear",
    value: function clear() {
      this._timer.clear();
    }
    /**
     * Resets the timer
     */

  }, {
    key: "reset",
    value: function reset() {
      var _this2 = this;

      this._timer.clear();

      this._timer = retimer(function () {
        return _this2.abort();
      }, this._ms);
    }
  }]);

  return TimeoutController;
}(AbortController);

module.exports = TimeoutController;
module.exports.TimeoutController = TimeoutController;